<template>
  <page>
    <v-card>
      <v-flex xs12>
        <message :messages="messages"></message>
      </v-flex>
      <v-card-title>
        <div>
          <div class="headline">Voyage Date Listing</div>
        </div>
        <v-spacer></v-spacer>
        <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
      </v-card-title>
      <v-data-table v-bind:headers="headers" v-bind:items="items" v-bind:search="search" :rows-per-page-items="itemsPerPage" v-bind:pagination.sync="pagination" item-key="name" :loading="loading" :no-data-text="noDataText" :filter="customSearch">
        <template slot="headerCell" slot-scope="props">
          <v-tooltip bottom>
            <span slot="activator">
              {{ props.header.text }}
            </span>
            <span>
              {{ props.header.text }}
            </span>
          </v-tooltip>
        </template>
        <template slot="items" slot-scope="props">
          <td class="text-xs-left">{{ props.item.voyDateType }}</td>
          <td class="text-xs-left">{{ props.item.voyDateDesc }}</td>
          <td class="text-xs-right">
            <table-action :rowData="props" review @review="doReview" remove @remove="doPromptRemove(props.item)"></table-action>
          </td>
        </template>
      </v-data-table>
      <v-btn color="primary" dark class="mb-2" @click="doNew">New Voyage Date<v-icon>mdi-plus</v-icon>
      </v-btn>
    </v-card>
    <v-dialog v-model="voyDateDialog" max-width="600px" persistent>
      <v-card>
        <v-card-title>
          <span class="headline">{{ labels.valueFormTitle }}</span>
        </v-card-title>
        <v-card-text>
          <message :messages="messages"></message>
          <form>
            <v-container grid-list-md>
              <v-layout row wrap>
                <v-flex xs6 v-if="newVoyDate">
                  <v-text-field v-model="voyDateForm.voyDateType" :label="labels.voyDateType" :error-messages="errors.collect('voyDateType')" data-vv-name="voyDateType" :data-vv-as="labels.voyDateType" v-validate="'required|param|max:8'"></v-text-field>
                </v-flex>
                <v-flex xs6 v-else>
                  <v-subheader class="queryLabel">{{labels.voyDateType}}</v-subheader>
                  <div class="subheading">{{voyDateForm.voyDateType}}</div>
                </v-flex>
                <v-flex xs6>
                  <v-text-field v-model="voyDateForm.voyDateDesc" :label="labels.voyDateDesc" :error-messages="errors.collect('voyDateDesc')" v-validate="'required|entry|max:100'" data-vv-name="voyDateDesc" :data-vv-as="labels.voyDateDesc"></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" flat @click.native="doClose">Cancel</v-btn>
          <v-btn color="primary" flat @click.native="doSave">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <confirm v-model="promptRemove" @ok="doRemove">
      Are you sure that you want to delete the selected Cargo Port? ({{deleteCrgoVoyDate}})
    </confirm>
  </page>
</template>

<script>
import * as TableConst from '@/mixins/table'
import { expandURI } from '@/utils/ajax'
import MessageMixin from '@/mixins/message'
export default {
  data() {
    return {
      headers: [
        { text: 'Voyage Date Type', value: 'voyDateType' },
        { text: 'Voyage Date Description', value: 'voyDateDesc' },
        TableConst.tableActionHeader
      ],
      labels: {
        valueFormTitle: 'Voyage Date Details',
        voyDateType: 'Voyage Date Type*',
        voyDateDesc: 'Voyage Date Description*'
      },
      voyDateForm: {
        voyDateType: null,
        voyDateDesc: null
      },
      filters: {
        voyDateType: null,
        voyDateDesc: null
      },
      voyDateDialog: null,
      newVoyDate: null,
      sumbitting: undefined,
      promptRemove: false,
      selectedCrgoVoyDate: undefined,
      deleteCrgoVoyDate: ''
    }
  },
  computed: {
    voyDate() {
      return this.$store.state.cargo.menu
    }
  },
  methods: {
    async init() {
      this.loading = true
      const apiURI = this.voyDate.getCrgoVoyDates
      if (apiURI) {
        try {
          const result = await this.$http.get(apiURI)
          const { data } = result.data
          if (data) {
            this.items = []
            data.map((voyDate) => {
              const convertVoyDate = {
                voyDateType: voyDate.voyDateType,
                voyDateDesc: voyDate.voyDateDesc
              }
              this.items.push(convertVoyDate)
            })
            this.loading = false
          }
        } catch (error) {
          this.loading = false
        }
      } else {
        this.loading = false
      }
    },
    async doInit() {
      this.init()
    },
    async doReview(data) {
      this.voyDateDialog = true
      this.newVoyDate = false
      const apiURI = this.voyDate.getCrgoVoyDate
      const expand = {
        voyDateType: data.item.voyDateType
      }
      if (apiURI) {
        const result = await this.$http.get(expandURI(apiURI, expand))
        const { data } = result.data
        if (result.data) {
          this.voyDateForm.voyDateType = data.voyDate.voyDateType
          this.voyDateForm.voyDateDesc = data.voyDate.voyDateDesc
        }
        this.voyDateDialog = true
      }
    },
    doNew() {
      this.resetValidator()
      this.resetMessages()
      this.newVoyDate = true
      this.voyDateDialog = true
    },
    doClose() {
      this.newVoyDate = false
      this.voyDateDialog = false
      this.voyDateForm.voyDateType = null
      this.voyDateForm.voyDateDesc = null
      this.resetValidator()
      this.resetMessages()
    },
    doSave() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.newVoyDate) {
            this.doCreate()
          } else {
            this.doUpdate()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doCreate() {
      const apiURI = this.voyDate.createVoyDate
      if (apiURI) {
        this.sumbitting = true
        try {
          const result = await this.$http.post(apiURI, this.voyDateForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.doInit()
            this.doClose()
          }
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    async doUpdate() {
      const apiURI = this.voyDate.updateVoyDate
      if (apiURI) {
        this.sumbitting = true
        try {
          const result = await this.$http.put(apiURI, this.voyDateForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.doInit()
            this.doClose()
          }
          this.submitting = false
        } catch (err) {
          const { data } = err.response.data
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    doPromptRemove(data) {
      if (data) {
        this.promptRemove = true
        this.selectedCrgoVoyDate = data
        this.deleteCrgoVoyDate = data.voyDateType + ' - ' + data.voyDateDesc
      }
    },
    async doRemove() {
      const apiURI = this.voyDate.deleteVoyDate
      if (apiURI) {
        this.loading = true
        const expand = {
          voyDateType: this.selectedCrgoVoyDate.voyDateType
        }
        try {
          const result = await this.$http.delete(expandURI(apiURI, expand))
          this.notify(result.data)
          // Reinit
          this.doInit()
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      } else {
        this.errorMessage('Invalid API URL')
      }
    }
  },
  created() {
    this.doInit()
  },
  mixins: [
    TableConst.default,
    MessageMixin
  ]
}
</script>

<style>
</style>
